<!-- 绑定邮箱组件 -->
<template id="bind_email">
  <section class="bind-email">
    <form class="s-form">
      <div class="s-form-row">
        <label class="s-form-label">邮箱：</label>
        <div class="s-form-info">
          <input type="email" placeholder="请输入邮箱地址" v-model="email" @input="validEmail" :class="{'error': emailError}" class="form-email"/>
        </div>
      </div>
      <send_code :type="v_type" :request="request()" :is_new="'true'" @revalid="revalid" @errorResult="errorResult"></send_code>
      <div class="s-form-btnrow">
        <button type="button" class="s-button submit s-btn-success" name="button" @click="next">提交</button>
      </div>
    </form>
    <v-alert :options="options"></v-alert>
  </section>
</template>

<script>
  import send_code from './../send_code.vue'
  import vAlert from '../../alert.vue'

  export default {
    data() {
      return {
        validateEmail: this.$root.config ? this.$root.config.validateEmail : '',
        email: '',
        emailError: null,
        v_type: 'email',
        options: {}
      }
    },
    computed: {
        emailValue () {
            return this.$store.state.verificaPhone;
        }
    },
    methods: {
      /*
       ** 整合验证信息
       */
      request() {
        return {
          email: this.email,
          // hasError: this.emailError
        }
      },
      /*
       ** 验证email
       */
      validEmail() {
        this.emailError = !this.validateEmail(this.email);
      },
      /*
       ** 验证输入
       */
      validate() {
        this.validEmail();

        let codeResult = this.$children[0].validateCode();

        if(!this.emailError && !codeResult){
          return true;
        }
        else{
          return false;
        }
      },
      /*
       ** 完成邮箱验证后下一步
       */
      next() {
        let result = this.validate();
        if(result){
          let req = {
            email: this.email,
            code: this.$children[0].code,
            precode: this.emailValue.precode,
            pretype: this.emailValue.pretype
          }

          axios.post(myUrl + 'profile/update/email/', qs.stringify(req)).then(response => {
            let res = response.data;

            if(res.code == 0 && res.result == true){
              this.$emit('bind_email_success', res.data);
              // this.$parent.$parent.statusList[0].value = res.data;
              this.$emit('next');
            }
            else{
              // console.log(res.message);
              this.options = {
                msgIsSuccess: false,
                msgText: res.message
              }
            }
          }, reject => {
            console.log(reject);
          });
        }
      },
      /*
       ** 捕获子组件重新验证的要求
       */
      revalid() {
        this.validEmail();
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      send_code,
      vAlert
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .bind-email{
    width: 810px;
    margin-top: 70px;
    .form-email{
      width: 360px;
    }
    .submit{
      width: 100px;
    }
  }
  .finish{
    padding-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// bind_email.vue?842ead66